export default {"src":"/_next/static/media/bg_standart_3.3d8ca83e.svg","height":109,"width":329,"blurWidth":0,"blurHeight":0};